import React, { useEffect, } from 'react'
import { Modal } from 'react-bootstrap'

import axios from 'axios';

import {
    dataTableLanguaje, responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync,
    languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings';
import { buildingModelGet } from '../../models/buildings/building';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { receiptModelGet } from '../../models/receipts/receipt';

const currentMethod = 'ReceiptsVariations';

const { app, colors, icons, images, labels, } = globalSettings;
const { backend, } = app;

const neutralValue = 0.00;

export default function ReceiptsVariations({
    $ = {},
    auth = '',
    building = buildingModelGet({}),
    // variation = {
    //     expenseConcept: conceptModelGet({}),
    //     variations: [],
    // },
    receiptsVariations = [{
        ...receiptModelGet({}),
        price: neutralValue,
        details: {
            price: neutralValue,
        },
        percentage: neutralValue,
    }],
    //setVariation = () => { },
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let data = [];
    let dataObj = {};
    let headerObj = {};
    const dtVariationsId = 'dtVariations';
    //const [expenseConceptDescription] = useState(variation?.expenseConcept?.description || '');
    const controls = {
        buttons: {
            print: {
                id: 'btnModalReceiptsVariationsPrint',
                className: 'btn btn-outline-secondary mx-1',
            },
            back: {
                id: 'btnModalReceiptsVariationsBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnModalReceiptsVariationsClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            conceptVariations: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtCondominiumBoardElectionsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtCondominiumBoardElectionsCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtVariationsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtVariationsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtCondominiumBoardElectionsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            print: {
                id: 'icoModalReceiptsVariationsPrint',
                className: icons?.print,
            },
            back: {
                id: 'icoModalReceiptsVariationsBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoModalReceiptsVariationsClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            // user: {
            //     id: 'inputModalReceiptsVariationsUser',
            //     className: 'form-control bg-transparent',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selModalReceiptsVariationsApartmet',
            //     className: 'form-select',
            // },
        },
        spinners: {
            print: {
                id: 'spModalReceiptsVariationsPrint',
                className: '',
            },
            back: {
                id: 'spModalReceiptsVariationsBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variations set
            response = await dataTableReceiptsVariationsSetAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                showModal(false);
                return;
            }
            //#endregion variations set

            //#region variations set (dataTable)
            if (!isUndNullEmp({ data: receiptsVariations, subMethod: currentMethod, })?.result && receiptsVariations?.length > 0) {
                receiptsVariations?.forEach((detail) => {
                    data?.push([
                        detail?.number,
                        dateTimeFormatGlobalSet({
                            date: detail?.from,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        separatorsNumbersSet({
                            number: detail?.details?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        separatorsNumbersSet({
                            number: detail?.percentage,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        detail?.id,
                    ]);
                });
            }

            $(`#${dtVariationsId}`)?.DataTable()?.rows?.add(data)?.draw(true);
            //#endregion variations set (dataTable)
        } catch (ex) {
            setShowModal(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            setShowModal(!isModalClose);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTableReceiptsVariationsSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableReceiptsVariationsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtVariationsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: labels?.receipt?.[languageObj?.id], orderable: false, width: '15%', },
                    { title: labels?.date?.[languageObj?.id], orderable: false, width: '20%', },
                    { title: labels?.amount?.[languageObj?.id], className: 'text-right', width: '40%', },
                    {
                        className: 'text-right',
                        title: labels?.variation?.[languageObj?.id],
                        render: function (data, type, row) {
                            //#region old code
                            //let dataObj.color = 'black';
                            //let dataObj.value = numberSet(data.replaceAll(',', ''), 'd').result;
                            //let dataObj.data = '';
                            //#endregion old code

                            //#region old code
                            // const dataObj = {
                            //     color: 'black',
                            //     value: numberSet({
                            //         //number: data.replaceAll(',', ''), 
                            //         number: data?.replaceAll(languageObj?.numbers?.separators?.thousands, ''),
                            //         type: 'd',
                            //         languageId: languageObj,
                            //         subMethod: currentMethod,
                            //     })?.result,
                            //     data: '',
                            // };
                            //#endregion old code

                            const dataObj = {
                                color: 'black',
                                value: data?.replaceAll(languageObj?.numbers?.separators?.thousands, ''),
                                data: '',
                            };

                            dataObj.value = languageObj?.numbers?.separators?.decimals === ',' ? dataObj?.value?.replaceAll(',', '.') : dataObj?.value;
                            dataObj.value = numberSet({
                                number: dataObj?.value,
                                type: 'd',
                                languageId: languageObj,
                                subMethod: currentMethod,
                            })?.result;

                            if (dataObj.value > 0.00) {
                                dataObj.color = colors?.warningColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.caretUp}'></i>  ${data}%</span>`;
                            } else if (dataObj.value === 0.00) {
                                dataObj.color = colors?.primaryColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.caretRight}'></i>  ${data}%</span>`;
                            } else if (dataObj.value < 0.00) {
                                dataObj.color = colors?.successColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.caretDown}'></i>  ${data}%</span>`;
                            }
                            return dataObj.data;
                        },
                        width: '25%',
                    },
                    {
                        title: '',
                        orderable: false,
                        searchable: false,
                        visible: true,
                        width: '0%',
                        render: function (data, type, row) {
                            return `<span id='${data}'></span>`;
                        },
                    },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //lengthChange: true, 
                lengthChange: false,
                //order: [[0, 'desc']],
                ordering: false,
                responsive: true,
                //searching: false,
                searching: true,
                //}).buttons().container().appendTo(`#${dtPurchasesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const variationsReportGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'variationsReportGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let receiptsVariationsLocal = [{
                ...receiptModelGet({}),
                price: neutralValue,
                details: {
                    price: neutralValue,
                },
                percentage: neutralValue,
            }];
            //#endregion variables

            //#region data check
            const dtRows = $(`#${dtVariationsId}`)?.DataTable().rows({ search: 'applied', }).nodes();
            if (dtRows?.length <= 0) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data check

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data get
            receiptsVariationsLocal = [];
            for (let index = 0; index < dtRows?.length; index++) {
                const rowId = dtRows?.[index]?.cells?.[4]?.children?.[0]?.id;
                const receiptVariationObj = receiptsVariations?.find(({ id, }) => id === rowId);
                receiptsVariationsLocal?.push(receiptVariationObj);
            }
            //#endregion data get

            //#region data save and get report
            const filterLocal = $(`#${dtVariationsId}`)?.DataTable().search();

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: building?.id,
                building: building,
                filter: filterLocal,
                method: backend?.methods?.receiptsVariations,
                user: auth?.user,
                details: receiptsVariationsLocal,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const reportObj = response?.result;
            window?.open(`/${globalSettings?.app?.reports?.receiptsVariationsPrint}/${reportObj?.id}`, '_blank');
            //#endregion data save and get report

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.print?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.print?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.user?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.selects?.apartment?.id}`).attr('disabled', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.conceptVariations?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.conceptVariations?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.print?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataSetAsync({ subMethod: 'form - onLoad', });
    }, [auth]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    {/* <img alt={labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.expenseConceptsLogo}></img> - {expenseConceptDescription} ({labels?.variations?.[languageObj?.id]}) */}
                    <img alt={labels?.receipts?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={images?.receiptsLogo}></img> - {labels?.receipts?.[languageObj?.id]} - ({labels?.variations?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    //className='close btn-danger fas fa-window-close'
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose' })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                {/* <div className='card card-outline card-primary shadow-lg'> */}
                {/*card header*/}
                {/* <div className='card-header'>
                        <h6 className='card-title'>
                            <img alt={labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.expenseConceptsLogo}></img> - {expenseConceptDescription}
                        </h6>
                    </div> */}

                {/*card body*/}
                {/* <div className='card-body'> */}
                <div className='row'>
                    <div className='col-md-12'>
                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                            <table id={dtVariationsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                        </div>
                    </div>
                </div>
                {/* </div> */}

                {/*card footer*/}
                {/* <div className='card-footer'>
                    <div className='form-group text-right'>
                        <button className='btn btn-outline-secondary mx-1'
                            onClick={(e) => variationsReportGetAsync(e)}
                            tooltip='tooltip'
                            title={labels?.toPrint?.[languageObj?.id]}
                            type='button'>
                            <i className={icons?.print}></i>
                        </button>
                        <button className='btn btn-outline-success'
                            onClick={() => defaultValueSetAsync(true)}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}>
                            <i className={icons?.arrowCircleLeft}></i>
                        </button>
                    </div>
                </div> */}
                {/* </div> */}
            </Modal.Body>
            <Modal.Footer className='card-footer'>
                <div className='form-group text-right'>
                    <button id={controls?.buttons?.print?.id}
                        className={controls?.buttons?.print?.className}
                        onClick={(e) => variationsReportGetAsync({ e: e, subMethod: 'btn - print', })}
                        tooltip='tooltip'
                        title={labels?.toPrint?.[languageObj?.id]}
                        type='button'>
                        <i id={controls?.icons?.print?.id} className={controls?.icons?.print?.className} /> <span id={controls?.spinners?.print?.id} className={controls?.spinners?.print?.className} aria-hidden={true}></span>
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btnBack' })}
                        tooltip='tooltip'
                        title={labels?.close?.[languageObj?.id]}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className={controls?.spinners?.back?.className} aria-hidden={true}></span>
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}